type PromiseResolve<T> = (value: T) => void;

type PromiseReject = (reason?: any) => void;

type PromiseWithResolversReturn<T> = {
  promise: Promise<T>;
  resolve?: PromiseResolve<T>;
  reject?: PromiseReject;
}

/**
 * Helper function that models the newely
 * available Promise.withResolvers method.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers
 */
export function promiseWithResolvers<T>(): PromiseWithResolversReturn<T> {
  let resolve: PromiseResolve<T> | undefined;
  let reject: ((reason?: unknown) => void) | undefined;
  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return { promise, resolve, reject };
}
